import { defineMessages } from 'react-intl';

export default defineMessages({
    includedFeatures: {
        id: 'ml.quoteandbind.common.includedFeatures.Included Features',
        defaultMessage: 'Included Features'
    }
});
